import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Text = styled(Typography)`
  display: flex;
  align-items: center;
  text-align: center;
`;
